import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { logout } from '../services/authService';
import { useAuth } from '../providers/AuthProvider';
export function useLogout() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { logoutWithAuthProvider } = useAuth();
    return async () => {
        await logout();
        logoutWithAuthProvider();
        queryClient.clear();
        navigate('/login', { replace: true });
    };
}
